import React, { useEffect, useState } from "react";
import "./AddMemberForm.css";
import PrimaryButton from "../../../Atoms/Buttons/Primary/PrimaryButton";
import useEdit from "../../../../Hooks/useEdit";
import useSave from "../../../../Hooks/useSave";
import TextFieldInput from "../../../Atoms/Inputs/TextField/TextFieldInput";
import { Formik } from "formik";
import * as Yup from "yup";
import { phone } from "phone";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { DemoContainer } from "@mui/x-date-pickers/internals/demo";
import dayjs from "dayjs";
import { toast } from "react-toastify";
import { TextField } from "@mui/material";
import config from "../../../../config";

const TeamSchema = Yup.object().shape({
  name: Yup.string().required("Member Name is required!"),
  nationalId: Yup.string()
    .matches(/^[0-9]+$/, "Valid National ID is required!")
    .min(8, "Valid National ID is required!")
    .max(20, "Valid National ID is required!")
    .required("Memeber National ID is required!"),
  birthday: Yup.date().required("Birthday is required!"),
});

function AddMemberForm({
  Edit = false,
  url,
  member,
  setMember,
  setOpen,
  page,
  search,
  navigateafter = true,
  setMembers,
  editId,
  setMembersUpdate,
}) {
  const [newObject, setNewObject] = useState({});
  const [goEdit, setGoEdit] = useState(false);
  const [goSave, setGoSave] = useState(false);
  const [dateError, setDateError] = useState("");
  const { state, loading: editLoading } = useEdit(
    `${url}/${editId}`,
    goEdit,
    setGoEdit,
    newObject,
    -1
  );
  const {
    saveState,
    loading: addLoading,
    newData,
  } = useSave({
    url: url,
    goSave,
    setGoSave,
    newObject,
    navigateAfter: navigateafter ? "/members" : null,
  });

  // useEffect(() => {
  //   if (state.dataRes.status == "success") {
  //     setOpen(false);
  //   }
  // }, [state]);

  useEffect(() => {
    if (saveState.dataRes.status == "success" && !navigateafter) {
      setOpen(false);
      setMembers([]);
      setMembersUpdate(true);
    }
  }, [saveState]);

  return (
    <div className="SmallFormWrapper">
      <Formik
        initialValues={{
          name: member?.name ?? "",
          birthday: member?.birthday ?? "",
          nationalId: member?.nationalId ?? "",
        }}
        validationSchema={TeamSchema}
        onSubmit={(values) => {
          if (member) {
            if (!dateError) {
              const prev = {
                name: member?.name ?? "",
                birthday: member?.birthday ?? "",
                nationalId: member?.nationalId ?? "",
              };
              setNewObject(
                Object.fromEntries(
                  Object.entries({
                    ...prev,
                    ...values,
                  }).filter(([key]) => prev[key] != values[key])
                )
              );
              setGoEdit(true);
            } else {
              toast.error(dateError, {
                position: "top-right",
                autoClose: 3000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnFocusLoss: false,
                pauseOnHover: true,
                draggable: true,
                theme: "colored",
              });
            }
          } else {
            setNewObject({
              ...values,
            });
            setGoSave(true);
          }
        }}
      >
        {({
          values,
          errors,
          touched,
          handleChange,
          handleBlur,
          handleSubmit,
        }) => (
          <form autoComplete="off" onSubmit={handleSubmit}>
            <div className="FormContainer" style={{ flexDirection: "column" }}>
              <div>
                <TextFieldInput
                  fullWidth
                  type="text"
                  placeholder={"Enter Member's Name"}
                  className="Input"
                  label={"Member's Name"}
                  name={"name"}
                  change={handleChange}
                  blur={handleBlur}
                  newValue={values.name}
                />
                {errors.name && touched.name && (
                  <p className="error">{errors.name}</p>
                )}
              </div>
              <div>
                <LocalizationProvider dateAdapter={AdapterDayjs}>
                  <DatePicker
                    format="YYYY-MM-DD"
                    maxDate={
                      member?.team
                        ? dayjs(
                            member?.team?.ageGroup?.maxBirthday
                              ?.split("T")
                              ?.at(0)
                          )
                        : null
                    }
                    minDate={
                      member?.team
                        ? dayjs(
                            member?.team?.ageGroup?.minBirthday
                              ?.split("T")
                              ?.at(0)
                          )
                        : null
                    }
                    className="Input full"
                    name={"birthday"}
                    label="Birth Date"
                    value={values.birthday ? dayjs(values.birthday) : ""}
                    onChange={(newValue) => {
                      if (
                        dayjs(newValue).isBetween(
                          dayjs(
                            member?.team?.ageGroup?.minBirthday
                              ?.split("T")
                              ?.at(0)
                          ),
                          dayjs(
                            member?.team?.ageGroup?.maxBirthday
                              ?.split("T")
                              ?.at(0)
                          ),
                          "day",
                          "[]"
                        ) ||
                        !member?.team
                      ) {
                        handleChange({
                          target: {
                            name: "birthday",
                            value: dayjs(newValue)
                              ?.set("hour", 12)
                              ?.format("YYYY-MM-DD"),
                          },
                        });
                        setDateError("");
                      } else {
                        setDateError(
                          "This birth date is not valid for his/her age group"
                        );
                      }
                    }}
                    fullWidth
                  />
                </LocalizationProvider>
                {errors.birthday && touched.birthday ? (
                  <p className="error">{errors.birthday}</p>
                ) : dateError ? (
                  <p className="error">{dateError}</p>
                ) : (
                  ""
                )}
              </div>
            </div>
            <div>
              <TextFieldInput
                fullWidth
                type="text"
                placeholder={"Enter Member's National ID"}
                className="Input"
                label={"Member's National ID"}
                name={"nationalId"}
                change={handleChange}
                blur={handleBlur}
                newValue={values.nationalId}
              />
              {errors.nationalId && touched.nationalId && (
                <p className="error">{errors.nationalId}</p>
              )}
            </div>

            <div style={{ display: "flex", justifyContent: "center" }}>
              <PrimaryButton
                classBtn={"center"}
                btnType={"submit"}
                text={Edit ? "Edit" : "Add"}
                loading={Edit ? editLoading : addLoading}
                style={{
                  textTransform: "capitalize",
                  marginTop: "10px",
                  width: "160px",
                  borderRadius: "5px",
                  color: config.SECONDARY_COLOR,
                  backgroundColor: config.PRIMARY_COLOR,
                }}
              />
            </div>
          </form>
        )}
      </Formik>
    </div>
  );
}

export default AddMemberForm;
